import { useSelector } from 'react-redux';

const TAG = '[useTestsOthers]';

/**
 * useTestsOthers - Hook to read other users' tests from Redux
 * Simple reader - no loading state (handled by OtherUsersTestsLoader)
 * @param {string} userId - The user ID to get tests for
 * Returns: { tests }
 */
export default function useTestsOthers(userId) {
  const tests = useSelector((s) => s.ovulationTests.otherUsersTests[userId] || []);
  return { tests };
}
